import { Divider, Stack } from '@mui/material';
import { TextInformation } from './TextInformation';
import { DownloadAndInfoButtons } from './Download&InfoButtons';
import { useIsDesktop } from 'Hooks';
import { IDisabilityConfirmation } from 'API/disabilityConfirmation';

interface IDisabilityConfirmationItem {
  disabilityConfirmation: IDisabilityConfirmation;
}

export const DisabilityConfirmationItem = ({
  disabilityConfirmation,
}: IDisabilityConfirmationItem) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems='center'
      bgcolor='white'
      padding={isDesktop ? '24px' : '16px 0 0 0'}
      borderRadius='16px'
      border='1px solid #E7EDFF'
      boxShadow={
        isDesktop ? undefined : '-2px -2px 10px 0px rgba(8, 30, 84, 0.04);'
      }
      gap={isDesktop ? '56px' : '24px'}
    >
      <TextInformation
        title={disabilityConfirmation.title}
        description={disabilityConfirmation.description}
      />
      {isDesktop && (
        <Divider
          orientation='vertical'
          sx={{ height: '72px', borderColor: 'primary.shade_200' }}
        />
      )}
      <DownloadAndInfoButtons
        attachmentId={disabilityConfirmation.attachmentId}
        disabilityName={disabilityConfirmation.disabilityName}
        moreInfoLink={disabilityConfirmation.linkInformation}
      />
    </Stack>
  );
};
